import { useParams } from "react-router";

type ParamName = "destinationIndex" | "addDestinationIndex";
export function useDestinationIndex(paramName: ParamName = "destinationIndex"): number {
  const params = useParams() as Record<ParamName, string>;
  return +params[paramName];
}
